<div class="form-group">

  <label [attr.for]="buildChildId()"
         [class.sr-only]="!label"
         [ngClass]="labelStyleModifier">
    {{label}}
  </label>

  <ng-select #ngSelect class="form-control custom-select" required
              [ngClass]="{'has-selected': isSelectedItem() === true}"
              [name]="name"
              [items]="options"
              [disabled]="disabled"
              [multiple]="multiple"
              bindValue="id"
              bindLabel="name"
              [placeholder]="placeholder"
              [searchable]="searchable"
              [virtualScroll]="virtualScroll"
              [closeOnSelect]="!multiple && closeOptionAfterSelecting"
              [(ngModel)]="model"
              (open)="onOpenDopdown($event)"
              (close)="onCloseDopdown($event)"
              (blur)="onBlur($event)"
              (change)="onSelect($event)"
              (mouseover)="onMouseOver()">
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div (click)="onClickOption(item.id, $event)" class="option-inner" title="{{item.name}}">{{item.name}}</div>
    </ng-template>
    <ng-template *ngIf="multiple" ng-multi-label-tmp let-items="items" let-clear="clear">
      <div class="ng-value" *ngFor="let item of (items ? items.slice(0,1): [])">
        {{placeholder}}
      </div>
    </ng-template>
  </ng-select>
  <achoo-validation-alerts [component]="this"></achoo-validation-alerts>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-filter-box/achoo-filter-box.component.html